module.exports = __webpack_public_path__ + "static/mob-img-2-a49e0b6d990258d498c8a0604d57853f.png";